import React from 'react';
import PropTypes from 'prop-types';

const StepItem = ({ slideActive, data, numStep }) =>
  <li
    data-target="#onboarding-carousel"
    data-item={`item-${numStep}`}
    className={`onboarding-steps-item ${slideActive ? 'active' : 'next'}`}
  >
    <span className="steps-item-icon" />
    <span className="steps-item-content">{data}</span>
  </li>;

StepItem.propTypes = {
  slideActive: PropTypes.bool.isRequired,
  data: PropTypes.string.isRequired,
  numStep: PropTypes.number.isRequired
};

export default StepItem;



// WEBPACK FOOTER //
// ./src/pages/jp/homepage/components/OnboardingFlow/components/StepItem.js